<template>
  <b-modal
    v-model="dataModal"
    centered
    no-close-on-backdrop
    no-close-on-esc
    title="Close Task"
    @close="onCloseModal">
    <div>
      <div
        class="call-select-modal__wrapper call-input">
        <b-form-textarea
          v-model="$v.dataForm.comment.$model"
          placeholder="Your comment..."
          rows="3"
          max-rows="6" />
      </div>
    </div>
    <template v-slot:modal-footer>
      <call-button
        :icon="dataCloseIcon"
        type="danger"
        plain
        @click="onCloseModal()">
        Cancel
      </call-button>
      <call-button
        :icon="dataRefreshIcon"
        type="success"
        :disabled="$v.$invalid"
        @click="clickCloseTask()">
        Close Task
      </call-button>
    </template>
  </b-modal>
</template>

<script>
import CallButton from '../CallButton';
import { BFormTextarea, BModal } from 'bootstrap-vue';
import iconsModal from '../../../mixins/iconsModal';
import { TASK_CLOSE } from '../../../store/types/actions.types';
import { validationMixin } from 'vuelidate';
import { required } from 'vuelidate/lib/validators';

export default {
  name: 'CallCloseTask',
  components: {
    CallButton,
    BModal,
    BFormTextarea
  },
  mixins: [validationMixin, iconsModal],
  props: {
    value: {
      type: Boolean,
      default: false
    },
    taskId: {
      type: [Number, String],
      default: null
    }
  },
  data () {
    return {
      dataModal: this.value,
      dataForm: {
        comment: null
      }
    };
  },
  watch: {
    async value () {
      this.dataModal = this.value;
      if (this.dataModal) {
        Object.assign(this.$data, this.$options.data.apply(this));
        this.$v.$reset();
      }
    }
  },
  validations: {
    dataForm: {
      comment: {
        required
      }
    }
  },
  methods: {
    onCloseModal () {
      this.$emit('input', false);
    },
    async clickCloseTask () {
      this.$v.$touch();
      if (this.$v.$invalid) {
        return false;
      }
      try {
        await this.$store.dispatch(`task/${TASK_CLOSE}`, {
          taskId: this.taskId,
          params: {
            ...this.dataForm
          },
          context: this
        });
        this.$emit('on-update');
        this.$Notify({
          title: 'Task',
          message: 'Closed successfully',
          type: 'success'
        });
        this.onCloseModal();
      } catch (e) {
        throw Error(e);
      }
    }
  }
};
</script>
